export const apuTypeFilters = {
    'name': {
        'inputType': 'text',
        'title': 'Name',
    },
    'manufacturer': {
        'inputType': 'dropdown',
        'title': 'Manufacturer',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
    },
    'aircraft_type': {
        'inputType': 'dropdown',
        'title': 'Aircraft Type',
        'options': [],
        'labelKey': 'name',
        'valueKey': 'id',
        'multiple': true
    },
}; 